import { render, staticRenderFns } from "./BoostPlansPage.vue?vue&type=template&id=09c25177&scoped=true&"
import script from "./BoostPlansPage.vue?vue&type=script&lang=js&"
export * from "./BoostPlansPage.vue?vue&type=script&lang=js&"
import style0 from "./BoostPlansPage.vue?vue&type=style&index=0&id=09c25177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c25177",
  null
  
)

export default component.exports